import { BarChart3, TrendingUp, PieChart, Target, Users, Database, GraduationCap } from 'lucide-react';
import caseStudies from './caseStudies.json';

export const mockData = {
  services: [
    {
      title: "Business Intelligence",
      description: "Transform raw data into actionable business insights with comprehensive BI solutions that drive informed decision-making across your organization.",
      icon: <BarChart3 className="w-6 h-6 text-white" />,
      features: ["Dashboard Creation", "KPI Tracking", "Real-time Reporting", "Data Integration"]
    },
    {
      title: "Data Visualization",
      description: "Create stunning, interactive visualizations that make complex data easy to understand and communicate to stakeholders at all levels.",
      icon: <PieChart className="w-6 h-6 text-white" />,
      features: ["Interactive Charts", "Custom Dashboards", "Data Storytelling", "Visual Analytics"]
    },
    {
      title: "Predictive Analytics",
      description: "Use machine learning and statistical models to forecast trends, spot opportunities, and flag risks before they hit your business.",
      icon: <TrendingUp className="w-6 h-6 text-white" />,
      features: ["Forecasting", "Risk Assessment", "ML Models", "Trend Analysis"]
    },
    {
      title: "Marketing Analytics",
      description: "Optimize your marketing campaigns with data-driven insights that improve ROI, customer acquisition, and retention strategies.",
      icon: <Target className="w-6 h-6 text-white" />,
      features: ["Campaign Analysis", "Customer Segmentation", "ROI Tracking", "Attribution Modeling"]
    },
    {
      title: "Data Strategy",
      description: "Develop comprehensive data strategies that align with your business objectives and create a roadmap for data-driven transformation.",
      icon: <Database className="w-6 h-6 text-white" />,
      features: ["Data Governance", "Strategy Planning", "Architecture Design", "Implementation"]
    },
    {
      title: "Advanced Analytics",
      description: "Unlock the power of advanced statistical methods, AI, and machine learning to solve complex business problems and drive innovation.",
      icon: <Users className="w-6 h-6 text-white" />,
      features: ["Statistical Analysis", "AI/ML Solutions", "Custom Models", "Research & Development"]
    },
    {
      title: "Analytics Training",
      description: "Empower your team with hands-on data analytics training and corporate data literacy programs that build lasting capabilities across your organization.",
      icon: <GraduationCap className="w-6 h-6 text-white" />,
      features: ["Tableau Training", "Power BI Workshops", "SQL Fundamentals", "Data Literacy Programs", "Data Storytelling"]
    }
  ],

  caseStudies,

  testimonials: [],

  stats: [
    {
      value: "10+",
      label: "Projects Delivered"
    },
    {
      value: "SAM",
      label: "Registered Small Business"
    },
    {
      value: "PL-300",
      label: "Power BI Data Analyst"
    },
    {
      value: "TDA",
      label: "Tableau Certified Data Analyst"
    }
  ],

  whyChooseUs: [
    "Published, hands-on dashboard work you can review before you hire us",
    "Expert team of data scientists and analysts with advanced degrees and certifications",
    "Comprehensive solutions tailored to your specific business needs and objectives",
    "End-to-end service from strategy development to implementation and ongoing support",
    "Deep, hands-on expertise across Tableau, Power BI, SQL, and modern analytics platforms",
    "Dedicated project management and transparent communication throughout engagement"
  ]
};